'use client'

// @ts-strict-ignore
import dynamic from 'next/dynamic'
import { ForwardRefExoticComponent, RefAttributes, useEffect } from 'react'

import { useBurger } from '@/features/burger/hooks/use-burger'

import { lockPageScroll } from '@/shared/lib/dom/lock-page-scroll'
import { withOpenClose, WithOpenCloseComponentProps } from '@/shared/lib/hocs/withOpenClose'
import { Overlay } from '@/shared/ui/Overlay/Overlay'

import { BurgerIcon } from './assets/burger-icon'
import { OffCanvasDialog } from './components/OffCanvasDialog/OffCanvasDialog'

import cl from './style.module.scss'

// The mobile burger menu pulls whole page shells (catalog, personal, region, enter).
// It's hidden until tapped, so load it on demand — critical for desktop where it never opens.
const BurgerMenu = dynamic(() => import('@/widgets/burger-menu').then(m => m.BurgerMenu), {
	ssr: false
})

const HeaderBurger = ({
	popupIsClosing,

	forwardedRef
}: WithOpenCloseComponentProps): JSX.Element => {
	const { isOpen, openSideBar, closeSideBar } = useBurger()

	useEffect(() => {
		if (!isOpen) return

		return lockPageScroll({ scrollY: window.scrollY || document.documentElement.scrollTop })
	}, [isOpen])

	return (
		<div className={cl.burger}>
			{/* Toggle button*/}
			<button
				className={cl.burgerMenuToggleButton}
				onClick={openSideBar}
				type="button"
				aria-label="Меню"
				aria-controls="menu-popup"
				aria-pressed={isOpen}>
				<BurgerIcon />
			</button>

			{/* Popup */}
			{isOpen && <Overlay onClick={closeSideBar} isClosing={popupIsClosing} />}
			<OffCanvasDialog hidden={!isOpen} isClosing={popupIsClosing} isOpened={isOpen} forwardedRef={forwardedRef}>
				{(isOpen || popupIsClosing) && <BurgerMenu />}
			</OffCanvasDialog>
		</div>
	)
}

export const OffCanvasPopupWithOpenClose: ForwardRefExoticComponent<RefAttributes<unknown>> =
	withOpenClose(HeaderBurger)
